import React from 'react';
import './spinner.css';

const Spinner = () => (
  <div className="spinner-overlay">
    <img className="mb-4" width={"100px"} src={require("../../images/Norsal-Transparent-bg.webp")} alt=""/>
    <div className="spinner"></div>
  </div>
);

export default Spinner;